import { API } from '@/api'

export const search = (query, type = 'all') => API.get(`/full_search/?search_str=${query}&search_type=${type}`);
export const fetchSuggestions = (query) => API.get(`/full_suggestions_search/?search_str=${query}`);
